module.exports = __webpack_public_path__ + "img/sensor_ldr.ef40d9ac.svg";